import moment from 'moment-timezone'
import Vue from 'vue'

require('./custom')

Vue.filter('dateTimeFormat', function (dateTime) {
  return moment.utc(dateTime).tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD HH:mm:ss')
})

Vue.filter('dateTimeWithoutSecondsFormat', function (dateTime) {
  return moment.utc(dateTime).tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD HH:mm')
})

Vue.filter('dateFormat', function (dateTime) {
  return moment.utc(dateTime).tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD')
})



// WEBPACK FOOTER //
// ./src/filters/index.js